module.exports = __webpack_public_path__ + "img/127.a2a6785b.jpg";